export const prepareOptionsForLocationSearch = (regions) => regions
  .map(region => ({ ...region, placesCount: region.districts.reduce((accumulator, district) => accumulator + district.placesCount, 0) }))
  .sort((a, b) => b.placesCount - a.placesCount)
  .slice(0, 10)
  .sort((a, b) => a.slug.toLowerCase().localeCompare(b.slug.toLowerCase()));
